import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { CustomerObjectType } from '../../../../../store/types/user'

type Props = {
  hydraToken: string
}

export const HydraGetMe = ({ hydraToken }: Props) => {
  const request: SendRequestType = {
    method: 'GET',
    url: '/customers/me',
    token: hydraToken,
    queryParams: { expand: 'profilePicture' },
  }

  return httpTools.sendRequest<CustomerObjectType>(request)
}
